import { useEffect, useRef } from 'react';
import Button from '../Button/Button';
import CancelRoundedIcon from '../IconButtons/CancelRoundedIcon';
import './ChatWelcome.css';

const ChatWelcome = ({ message, mobile, configuration, onClose, onClick, onWelcomePopupEntering }) =>
{
  function closePopup(event) {
    event.stopPropagation();
    onClose();
  }

  const ref = useRef<HTMLInputElement>();

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const resizeObserver = new ResizeObserver(() => {
      if (ref.current) {
        onWelcomePopupEntering(ref.current.scrollHeight);
      }
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);

  return (
    <div className="chat-welcome" ref={ref}>
      {
        mobile ?
          <div className="chat-welcome-mobile">
            <Button className="chat-welcome-mobile-close-button" onClick={closePopup} type="icon">
              <CancelRoundedIcon />
            </Button>
            {message}
          </div>
          :
          <div className="chat-welcome-desktop" onClick={onClick}>
            <div className="chat-welcome-message">
              <img className="chat-welcome-avatar" src={`${configuration.avatar.trim()}`} alt="AIBot" />
              <div className="chat-welcome-bubble">
                <p className="chat-welcome-secondary-welcome">{message}</p>
              </div>
              <Button className="chat-welcome-close-button" onClick={closePopup} type="icon">
                <CancelRoundedIcon />
              </Button>
            </div>
          </div>
      }
    </div>
  );
};


export default ChatWelcome;